import { atom } from 'recoil';

export const adminColorState = atom({
  key: 'adminColorState',
  default: [],
});
